import clsx from 'clsx';
type UserRoleDisplayProps = {
  isBorrower: boolean;
};

export default function UserRoleDisplay({ isBorrower }: UserRoleDisplayProps) {
  const title = isBorrower ? 'Borrower' : 'Investor';

  return (
    <div
      className={clsx(
        'inline-flex items-center justify-center px-2.5 rounded-[10px] gap-2 w-[88px] h-[18px] pb-[2px]',
        isBorrower ? 'bg-[#3E0775]' : 'bg-[#073575]'
      )}
    >
      <span className="text-white text-[15px] font-avenir font-normal break-words w-full text-center leading-[18px]">
        {title}
      </span>
    </div>
  );
}
